<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование менеджера" : "Добавление менеджера"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
            label='Опубликовать'
          )
        v-flex(xs12)
          s-autocomplete(
            v-model='model.manager'
            label='Менеджер'
            item-text='full_name'
            item-value='id'
            data-source='admin/managers'
            :rules='[v => v && !!Object.keys(v).length || "Выберите менеджера"]'
            :params='{ count: 50 }'
            :inner-data='true'
          )
        v-flex(xs12 sm8)
          v-text-field(
            :error='errors.has("position")'
            :error-messages='errors.first("position")'
            v-model='model.position'
            label='Должность'
          )
        v-flex(xs12 sm4)
          v-checkbox(
            v-model='model.in_head_office'
            label='Вывести в основном списке'
            color='primary'
          )
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("alt_phone")'
            :error-messages='errors.first("alt_phone")'
            v-model='model.alt_phone'
            label='Альтернативный номер'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {}
  }),

  async created() {
    if (this.id===undefined) {
      this.model.published = true
      return
    }
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async onSave() {
      if (this.model.manager) {
        this.model.manager_id = this.model.manager.id
      }
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Development.Managers' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    ...mapActions('development/managers', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('development/managers', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
